import "./index.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import "react-toastify/dist/ReactToastify.css";
import TableLoader from "./components/common/TableLoader/TableLoader";
import RGlobalToast from "./hooks/RGlobalToast";
import Authenticate from "./auth/Authenticate";
import { Provider } from 'react-redux';
import { store } from '@src/app/store/store';

// Lazy-loaded components
const lazyLoad = (importPromise: any) => {
  const LazyComponent = lazy(() => importPromise);
  return (props: any) => (
    <Suspense
      fallback={
        <div>
          <TableLoader />
        </div>
      }
    >
      <LazyComponent {...props} />
    </Suspense>
  );
};


// routes array
const allRoutes = [
  { path: "/auth", element: <Authenticate /> },
  { path: "/dashboard", element: <Authenticate /> },
];

const App = () => {
  const router = createBrowserRouter(allRoutes);
  return (
    <div className="whitespace-normal outline-none">
      <Provider store={store}>
      <RGlobalToast />
      <RouterProvider router={router} />
      </Provider>
    </div>
  );
};

export default App;
